import ABTesting from './svg/ABTesting.svg'
import ABTestingAnalytics from './svg/ABTestingAnalytics.svg'
import ABTestingMetrics from './svg/ABTestingMetrics.svg'
import ABTestingTargeting from './svg/ABTestingTargeting.svg'
import ActionBar from './svg/ActionBar.svg'
import ActivateAccount from './svg/ActivateAccount.svg'
import Activation from './svg/Activation.svg'
import ActiveRectangle from './svg/ActiveRectangle.svg'
import Add from './svg/Add.svg'
import AddCircle from './svg/AddCircle.svg'
import AddCircleLarge from './svg/AddCircleLarge.svg'
import AddPlus from './svg/AddPlus.svg'
import AddPlusBold from './svg/AddPlusBold.svg'
import AddPlusGrey from './svg/AddPlusGrey.svg'
import AddQueryBuilder from './svg/AddQueryBuilder.svg'
import AI from './svg/AI.svg'
import Alias from './svg/Alias.svg'
import AliasActive from './svg/AliasActive.svg'
import AliasIcon from './svg/AliasIcon.svg'
import AliasLarge from './svg/AliasLarge.svg'
import AliasName from './svg/AliasName.svg'
import Alignment from './svg/Alignment.svg'
import Analytics from './svg/Analytics.svg'
import AnalyticsDashboardModuleLarge from './svg/AnalyticsDashboardModuleLarge.svg'
import AndDark from './svg/AndDark.svg'
import ApiCalls from './svg/ApiCalls.svg'
import ApiConsole from './svg/ApiConsole.svg'
import ApiDoc from './svg/ApiDoc.svg'
import ApiDocs from './svg/ApiDocs.svg'
import ApiTokens from './svg/ApiTokens.svg'
import ApiTokensLarge from './svg/ApiTokensLarge.svg'
import ApkLarge from './svg/ApkLarge.svg'
import ArchiveActive from './svg/ArchiveActive.svg'
import ArchiveLarge from './svg/ArchiveLarge.svg'
import ArchiveMedium from './svg/ArchiveMedium.svg'
import ArrowDown from './svg/ArrowDown.svg'
import ArrowSquare from './svg/ArrowSquare.svg'
import ArrowUp from './svg/ArrowUp.svg'
import Asset from './svg/Asset.svg'
import Archive from './svg/AssetArchive.svg'
import Audio from './svg/AssetAudio.svg'
import Code from './svg/AssetCode.svg'
import Document from './svg/AssetDocument.svg'
import Executable from './svg/AssetExecutable.svg'
import Folder from './svg/AssetFolder.svg'
import FolderOpen from './svg/AssetFolderOpen.svg'
import AssetFullScreen from './svg/AssetFullScreen.svg'
import AssetImage from './svg/AssetImage.svg'
import AssetModuleLarge from './svg/AssetModuleLarge.svg'
import Assets from './svg/Assets.svg'
import AssetSelected from './svg/AssetSelected.svg'
import Video from './svg/AssetVideo.svg'
import AssetZoom from './svg/AssetZoom.svg'
import AudienceExperience from './svg/AudienceExperience.svg'
import AudioActive from './svg/AudioActive.svg'
import AudioLarge from './svg/AudioLarge.svg'
import AudioMedium from './svg/AudioMedium.svg'
import Audit from './svg/Audit.svg'
import AuditlogLarge from './svg/AuditlogLarge.svg'
import Automation from './svg/Automation.svg'
import AVI from './svg/AVI.svg'
import BackArrow from './svg/BackArrow.svg'
import BackArrowSquare from './svg/BackArrowSquare.svg'
import Backward from './svg/Backward.svg'
import Bandwidth from './svg/Bandwidth.svg'
import Bin from './svg/Bin.svg'
import Bold from './svg/Bold.svg'
import Boolean from './svg/Boolean.svg'
import BooleanSmall from './svg/BooleanSmall.svg'
import Branch from './svg/Branch.svg'
import BranchActive from './svg/BranchActive.svg'
import BranchIcon from './svg/BranchIcon.svg'
import BranchIcon2 from './svg/BranchIcon2.svg'
import BranchLarge from './svg/BranchLarge.svg'
import BranchSetting from './svg/BranchSetting.svg'
import BranchTree from './svg/BranchTree.svg'
import Bucket from './svg/Bucket.svg'
import BucketLight from './svg/BucketLight.svg'
import Bulb from './svg/Bulb.svg'
import BulkTaskLarge from './svg/BulkTaskLarge.svg'
import BulkTaskQueue from './svg/BulkTaskQueue.svg'
import Bullet from './svg/Bullet.svg'
import Cancel from './svg/Cancel.svg'
import CancelCircle from './svg/CancelCircle.svg'
import CancelLarge from './svg/CancelLarge.svg'
import CancelMedium from './svg/CancelMedium.svg'
import CancelPurple from './svg/CancelPurple.svg'
import CancelSec from './svg/CancelSec.svg'
import CancelSmall from './svg/CancelSmall.svg'
import CancelTransparent from './svg/CancelTransparent.svg'
import CellNetwork from './svg/CellNetwork.svg'
import ChangeVersion from './svg/ChangeVersion.svg'
import ChangeView from './svg/ChangeView.svg'
import Chat from './svg/Chat.svg'
import ChatSelected from './svg/ChatSelected.svg'
import ChatSupport from './svg/ChatSupport.svg'
import ChatSupportActive from './svg/ChatSupportActive.svg'
import Check from './svg/Check.svg'
import CheckboxActive from './svg/CheckboxActive.svg'
import CheckboxDisabled from './svg/CheckboxDisabled.svg'
import CheckboxInactive from './svg/CheckboxInactive.svg'
import Checked from './svg/Checked.svg'
import CheckedCircle from './svg/CheckedCircle.svg'
import CheckedPurple from './svg/CheckedPurple.svg'
import CheckedTransparent from './svg/CheckedTransparent.svg'
import CheckedWhite from './svg/CheckedWhite.svg'
import ChevronDown from './svg/ChevronDown.svg'
import ChevronDownTransparent from './svg/ChevronDownTransparent.svg'
import ChevronExtraSmall from './svg/ChevronExtraSmall.svg'
import ChevronRight from './svg/ChevronRight.svg'
import ChevronSmall from './svg/ChevronSmall.svg'
import ChevronUp from './svg/ChevronUp.svg'
import ChevronUpTransparent from './svg/ChevronUpTransparent.svg'
import ClickAlias from './svg/ClickAlias.svg'
import Clock from './svg/Clock.svg'
import ClockDark from './svg/ClockDark.svg'
import Close from './svg/Close.svg'
import Code2 from './svg/Code2.svg'
import CodeActive from './svg/CodeActive.svg'
import CodeLarge from './svg/CodeLarge.svg'
import CodeMedium from './svg/CodeMedium.svg'
import CodeSecondary from './svg/CodeSecondary.svg'
import ColumnSelector from './svg/ColumnSelector.svg'
import ComfortView from './svg/ComfortView.svg'
import CompactView from './svg/CompactView.svg'
import Compare from './svg/Compare.svg'
import CompletedTask from './svg/CompletedTask.svg'
import Compress from './svg/Compress.svg'
import Contains from './svg/Contains.svg'
import ContainsSquare from './svg/ContainsSquare.svg'
import ContentFlyEnvironments from './svg/ContentFlyEnvironments.svg'
import ContentFlyEnvironmentsActive from './svg/ContentFlyEnvironmentsActive.svg'
import ContentFlyEnvironmentsFilled from './svg/ContentFlyEnvironmentsFilled.svg'
import ContentModels from './svg/ContentModels.svg'
import ContentModelSelected from './svg/ContentModelSelected.svg'
import ContentModelsMedium from './svg/ContentModelsMedium.svg'
import ContentModelsMediumActive from './svg/ContentModelsMediumActive.svg'
import ContentStack from './svg/ContentStack.svg'
import ContentStackRedLogo from './svg/ContentStackRedLogo.svg'
import Copy from './svg/Copy.svg'
import CopyIconSmall from './svg/CopyIconSmall.svg'
import CopyUrl from './svg/CopyUrl.svg'
import CopyUrlTiny from './svg/CopyUrlTiny.svg'
import CopyWhite from './svg/CopyWhite.svg'
import CreatedAt from './svg/CreatedAt.svg'
import CreateWhite from './svg/CreateWhite.svg'
import CSLogo from './svg/CSLogo.svg'
import CSLogoLarge from './svg/CSLogoLarge.svg'
import CSS from './svg/CSS.svg'
import CSV from './svg/CSV.svg'
import CTModuleLarge from './svg/CTModuleLarge.svg'
import Custom from './svg/Custom.svg'
import CustomField from './svg/CustomField.svg'
import CustomSmall from './svg/CustomSmall.svg'
import CustomWidget from './svg/CustomWidget.svg'
import DarkStar from './svg/DarkStar.svg'
import Dashboard from './svg/Dashboard.svg'
import DashboardModuleLarge from './svg/DashboardModuleLarge.svg'
import DashboardWidget from './svg/DashboardWidget.svg'
import Date from './svg/Date.svg'
import DateSmall from './svg/DateSmall.svg'
import DefaultEnv from './svg/DefaultEnv.svg'
import Delete from './svg/Delete.svg'
import DeleteAsset from './svg/DeleteAsset.svg'
import DeleteQueryBuilder from './svg/DeleteQueryBuilder.svg'
import DeleteSmall from './svg/DeleteSmall.svg'
import DeleteTransparent from './svg/DeleteTransparent.svg'
import DeleteTransparentLarge from './svg/DeleteTransparentLarge.svg'
import Delivery from './svg/Delivery.svg'
import DeliveryActive from './svg/DeliveryActive.svg'
import Deploy from './svg/Deploy.svg'
import DeployActive from './svg/DeployActive.svg'
import DeployDefault from './svg/DeployDefault.svg'
import DeployDisabled from './svg/DeployDisabled.svg'
import DeploymentFilled from './svg/DeploymentFilled.svg'
import DeployOutline from './svg/DeployOutline.svg'
import Description from './svg/Description.svg'
import Development from './svg/Development.svg'
import Disable from './svg/Disable.svg'
import DisableDark from './svg/DisableDark.svg'
import DisableGray from './svg/DisableGray.svg'
import DisableLarge from './svg/DisableLarge.svg'
import DiscussionModuleLarge from './svg/DiscussionModuleLarge.svg'
import Disk from './svg/Disk.svg'
import Display from './svg/Display.svg'
import DOC2 from './svg/DOC2.svg'
import Docs from './svg/Docs.svg'
import DocumentActive from './svg/DocumentActive.svg'
import DocumentLarge from './svg/DocumentLarge.svg'
import DocumentMedium from './svg/DocumentMedium.svg'
import DoesNotContainsSquare from './svg/DoesNotContainsSquare.svg'
import DontSave from './svg/DontSave.svg'
import DoubleArrow from './svg/DoubleArrow.svg'
import DoubleArrowSquare from './svg/DoubleArrowSquare.svg'
import DownArrow from './svg/DownArrow.svg'
import DownArrowDisabled from './svg/DownArrowDisabled.svg'
import DownArrowEnabled from './svg/DownArrowEnabled.svg'
import Download from './svg/Download.svg'
import Dropdown from './svg/Dropdown.svg'
import DropdownChevronDark from './svg/DropdownChevronDark.svg'
import DropdownDark from './svg/DropdownDark.svg'
import DuplicateSmall from './svg/DuplicateSmall.svg'
import Edit from './svg/Edit.svg'
import EditSmall from './svg/EditSmall.svg'
import EditSmallActive from './svg/EditSmallActive.svg'
import EditTransparent from './svg/EditTransparent.svg'
import Email from './svg/Email.svg'
import EmailWhite from './svg/EmailWhite.svg'
import Embed from './svg/EmbedEntry.svg'
import Enable from './svg/Enable.svg'
import EnableGray from './svg/EnableGray.svg'
import Entries from './svg/Entries.svg'
import EntryChat from './svg/EntryChat.svg'
import EntryChatAlert from './svg/EntryChatAlert.svg'
import EntryComment from './svg/EntryComment.svg'
import EntryModuleLarge from './svg/EntryModuleLarge.svg'
import EntryStructureOutline from './svg/EntryStructureOutline.svg'
import Env from './svg/Env.svg'
import EnvironmentColor from './svg/EnvironmentColor.svg'
import EnvironmentsLarge from './svg/EnvironmentsLarge.svg'
import Equals from './svg/Equals.svg'
import EqualToSquare from './svg/EqualToSquare.svg'
import Error from './svg/Error.svg'
import ErrorCircle from './svg/ErrorCircle.svg'
import ErrorInverted from './svg/ErrorInverted.svg'
import ErrorWhite from './svg/ErrorWhite.svg'
import EUROPE from './svg/EU.svg'
import EXE from './svg/EXE.svg'
import ExecutableActive from './svg/ExecutableActive.svg'
import Expand from './svg/Expand.svg'
import ExperienceContainer from './svg/ExperienceContainer.svg'
import ExperienceContainerPink from './svg/ExperienceContainerPink.svg'
import Export from './svg/Export.svg'
import ExportActive from './svg/ExportActive.svg'
import Extension from './svg/Extension.svg'
import ExtensionLarge from './svg/ExtensionLarge.svg'
import ExtensionModuleLarge from './svg/ExtensionModuleLarge.svg'
import ExtensionPurple from './svg/ExtensionPurple.svg'
import ExtensionPurpleCircle from './svg/ExtensionPurpleCircle.svg'
import ExtensionSmallFilled from './svg/ExtensionSmallFilled.svg'
import Eye from './svg/Eye.svg'
import EyeClose from './svg/EyeClose.svg'
import FailTransferOwnership from './svg/FailTransferOwnership.svg'
import Feedback from './svg/Feedback.svg'
import File from './svg/File.svg'
import FileSmall from './svg/FileSmall.svg'
import Filter from './svg/Filter.svg'
import FolderLarge from './svg/FolderLarge.svg'
import FolderMedium from './svg/FolderMedium.svg'
import FolderModuleLarge from './svg/FolderModuleLarge.svg'
import ForgotPassword from './svg/ForgotPassword.svg'
import Forward from './svg/Forward.svg'
import ForwardWhite from './svg/ForwardWhite.svg'
import FullScreenMode from './svg/FullScreenMode.svg'
import GFModuleLarge from './svg/GFModuleLarge.svg'
import GitBranch from './svg/GitBranch.svg'
import Global from './svg/Global.svg'
import GlobalFields from './svg/GlobalFields.svg'
import GlobalFieldSelectedSmall from './svg/GlobalFieldSelectedSmall.svg'
import GlobalFieldSmall from './svg/GlobalFieldSmall.svg'
import GlobalFieldsMedium from './svg/GlobalFieldsMedium.svg'
import GlobalFieldsMediumActive from './svg/GlobalFieldsMediumActive.svg'
import GlobalSmall from './svg/GlobalSmall.svg'
import GlobeWithCursor from './svg/GlobeWithCursor.svg'
import GlobeWithCursorActive from './svg/GlobeWithCursorActive.svg'
import GreaterThan from './svg/GreaterThan.svg'
import GreaterThanEquals from './svg/GreaterThanEquals.svg'
import GreaterThanSquare from './svg/GreaterThanSquare.svg'
import GreenChecked from './svg/GreenChecked.svg'
import GreyAdd from './svg/GreyAdd.svg'
import GridView from './svg/GridView.svg'
import Group from './svg/Group.svg'
import GroupField from './svg/GroupField.svg'
import GroupPermission from './svg/GroupPermission.svg'
import GroupSmall from './svg/GroupSmall.svg'
import H1 from './svg/H1.svg'
import H2 from './svg/H2.svg'
import H3 from './svg/H3.svg'
import H4 from './svg/H4.svg'
import H5 from './svg/H5.svg'
import H6 from './svg/H6.svg'
import HalfHeart from './svg/HalfHeart.svg'
import Hamburger from './svg/Hamburger.svg'
import HasAnyValueSquare from './svg/HasAnyValueSquare.svg'
import HasNoValueSquare from './svg/HasNoValueSquare.svg'
import Help from './svg/Help.svg'
import HelpCentre from './svg/HelpCentre.svg'
import HelpDocs from './svg/HelpDocs.svg'
import HelpExtraLarge from './svg/HelpExtraLarge.svg'
import HelpExtraLargeActive from './svg/HelpExtraLargeActive.svg'
import HelpExtraLargeNotification from './svg/HelpExtraLargeNotification.svg'
import HelpLarge from './svg/HelpLarge.svg'
import HelpSmall from './svg/HelpSmall.svg'
import HoverAlias from './svg/HoverAlias.svg'
import Html from './svg/Html.svg'
import HTML2 from './svg/HTML2.svg'
import IconCopy from './svg/IconCopy.svg'
import Image from './svg/Image.svg'
import ImageActive from './svg/ImageActive.svg'
import ImageAssetFullscreen from './svg/ImageAssetFullscreen.svg'
import ImageLarge from './svg/ImageLarge.svg'
import Import from './svg/Import.svg'
import ImportActive from './svg/ImportActive.svg'
import ImportWhite from './svg/ImportWhite.svg'
import Info from './svg/Info.svg'
import InfoCircle from './svg/InfoCircle.svg'
import InfoCircleWhite from './svg/InfoCircleWhite.svg'
import InfoGreen from './svg/InfoGreen.svg'
import InfoInvertedWhite from './svg/InfoInvertedWhite.svg'
import InfoLight from './svg/InfoLight.svg'
import Information from './svg/Information.svg'
import Information2 from './svg/Information2.svg'
import InformationSmall from './svg/InformationSmall.svg'
import InformationSmallPurple from './svg/InformationSmallPurple.svg'
import InformationWithDot from './svg/InformationWithDot.svg'
import InfoSecondary from './svg/InfoSecondary.svg'
import InfoSmall from './svg/InfoSmall.svg'
import InfoYellow from './svg/InfoYellow.svg'
import Intercom from './svg/Intercom.svg'
import Invitation from './svg/Invitation.svg'
import InviteUser from './svg/InviteUser.svg'
import IsFalseSquare from './svg/IsFalseSquare.svg'
import IsTrueSquare from './svg/IsTrueSquare.svg'
import Italic from './svg/Italic.svg'
import JPG from './svg/JPG.svg'
import JS from './svg/JS.svg'
import JSON from './svg/JSON.svg'
import Key from './svg/Key.svg'
import KeyboardShortcut from './svg/KeyboardShortcut.svg'
import Language from './svg/Language.svg'
import LanguageDark from './svg/LanguageDark.svg'
import Layout from './svg/Layout.svg'
import LearnMore from './svg/LearnMore.svg'
import LeaveStack from './svg/LeaveStack.svg'
import LeaveStackWhite from './svg/LeaveStackWhite.svg'
import Left from './svg/Left.svg'
import LeftArrow from './svg/LeftArrow.svg'
import LeftArrowGray from './svg/LeftArrowGray.svg'
import LeftConnector from './svg/LeftConnector.svg'
import Leftmost from './svg/Leftmost.svg'
import LessThan from './svg/LessThan.svg'
import LessThanEquals from './svg/LessThanEquals.svg'
import LessThanSquare from './svg/LessThanSquare.svg'
import LightBulb from './svg/LightBulb.svg'
import Link from './svg/Link.svg'
import Link2 from './svg/Link2.svg'
import LinkSmall from './svg/LinkSmall.svg'
import LinkWhite from './svg/LinkWhite.svg'
import List from './svg/List.svg'
import List2 from './svg/List2.svg'
import LivePreview from './svg/LivePreview.svg'
import Lock from './svg/Lock.svg'
import LockSmall from './svg/LockSmall.svg'
import Login from './svg/Login.svg'
import LoginError from './svg/LoginError.svg'
import Logo from './svg/Logo.svg'
import Management from './svg/Management.svg'
import ManagementActive from './svg/ManagementActive.svg'
import ManageWidget from './svg/ManageWidget.svg'
import ManageWidgetsLarge from './svg/ManageWidgetsLarge.svg'
import Markdown from './svg/Markdown.svg'
import MarkdownSmall from './svg/MarkdownSmall.svg'
import Marketplace from './svg/Marketplace.svg'
import MarketplaceSmallFilled from './svg/MarketplaceSmallFilled.svg'
import MarketplaceSmallFilledGray from './svg/MarketplaceSmallFilledGray.svg'
import MarketplaceSmallFilledWhite from './svg/MarketplaceSmallFilledWhite.svg'
import Maximize from './svg/Maximize.svg'
import Minimize from './svg/Minimize.svg'
import Minus from './svg/Minus.svg'
import MinusGreySmall from './svg/MinusGreySmall.svg'
import MinusSign from './svg/MinusSign.svg'
import ModifiedBy from './svg/ModifiedBy.svg'
import ModularBlocks from './svg/ModularBlocks.svg'
import ModularBlocksSmall from './svg/ModularBlocksSmall.svg'
import ModuleError from './svg/ModuleError.svg'
import Move from './svg/Move.svg'
import MoveHere from './svg/MoveHere.svg'
import MoveIcon from './svg/MoveIcon.svg'
import MoveSmall from './svg/MoveSmall.svg'
import MoveTo from './svg/MoveTo.svg'
import MP3 from './svg/MP3.svg'
import MP4 from './svg/MP4.svg'
import MultiCT from './svg/MultiCT.svg'
import MultiLineText from './svg/MultiLineText.svg'
import MultiLineTextSmall from './svg/MultiLineTextSmall.svg'
import NewComment from './svg/NewComment.svg'
import NewEntry from './svg/NewEntry.svg'
import NewFolder from './svg/NewFolder.svg'
import NewTab from './svg/NewTab.svg'
import NewTabLight from './svg/NewTabLight.svg'
import NoBranch from './svg/NoBranch.svg'
import NoCommentBanner from './svg/NoCommentBanner.svg'
import NotEquals from './svg/NotEquals.svg'
import NotEqualToSquare from './svg/NotEqualToSquare.svg'
import NotificationActive from './svg/NotificationActive.svg'
import NotificationAlert from './svg/NotificationAlert.svg'
import NotificationAtRest from './svg/NotificationAtRest.svg'
import NotificationModuleLarge from './svg/NotificationModuleLarge.svg'
import NotPublish from './svg/NotPublish.svg'
import Number from './svg/Number.svg'
import NumberSmall from './svg/NumberSmall.svg'
import OngoingTask from './svg/OngoingTask.svg'
import OnPower from './svg/OnPower.svg'
import OnPowerWhite from './svg/OnPowerWhite.svg'
import OpenLock from './svg/OpenLock.svg'
import OpenLockDisabled from './svg/OpenLockDisabled.svg'
import OrgSettings from './svg/OrgSettings.svg'
import PageConstructionError from './svg/PageConstructionError.svg'
import PageNotFound from './svg/PageNotFound.svg'
import PageNotFoundError from './svg/PageNotFoundError.svg'
import Paragraph from './svg/Paragraph.svg'
import Pause from './svg/Pause.svg'
import Pdf from './svg/Pdf.svg'
import PDF2 from './svg/PDF2.svg'
import PdfLarge from './svg/PdfLarge.svg'
import PersonalizationAttributes from './svg/PersonalizationAttributes.svg'
import PersonalizationAttributesActive from './svg/PersonalizationAttributesActive.svg'
import PersonalizationAttributesLarge from './svg/PersonalizationAttributesLarge.svg'
import PersonalizationAudiences from './svg/PersonalizationAudiences.svg'
import PersonalizationAudiencesActive from './svg/PersonalizationAudiencesActive.svg'
import PersonalizationAudiencesLarge from './svg/PersonalizationAudiencesLarge.svg'
import PersonalizationEventsLarge from './svg/PersonalizationEventLarge.svg'
import PersonalizationEvents from './svg/PersonalizationEvents.svg'
import PersonalizationEventsActive from './svg/PersonalizationEventsActive.svg'
import PersonalizationExperiences from './svg/PersonalizationExperiences.svg'
import PersonalizationExperiencesActive from './svg/PersonalizationExperiencesActive.svg'
import PersonalizationExperiencesLarge from './svg/PersonalizationExperiencesLarge.svg'
import PersonalizationLogo from './svg/PersonalizationLogo.svg'
import PersonalizationLogoGrey from './svg/PersonalizationLogoGrey.svg'
import PersonalizationLogoGreySmall from './svg/PersonalizationLogoGreySmall.svg'
import PersonalizationVariations from './svg/PersonalizationVariations.svg'
import Pie from './svg/Pie.svg'
import Pin from './svg/Pin.svg'
import Plus from './svg/Plus.svg'
import PlusBold from './svg/PlusBold.svg'
import PlusGreySmall from './svg/PlusGreySmall.svg'
import PlusPurple from './svg/PlusPurple.svg'
import PlusSign from './svg/PlusSign.svg'
import PNG from './svg/PNG.svg'
import Podium from './svg/Podium.svg'
import PopoutClose from './svg/PopoutClose.svg'
import PPT from './svg/PPT.svg'
import Preferences from './svg/Preferences.svg'
import Proceed from './svg/Proceed.svg'
import ProceedActive from './svg/ProceedActive.svg'
import Production from './svg/Production.svg'
import ProductTour from './svg/ProductTour.svg'
import Profile from './svg/Profile.svg'
import ProfileDark from './svg/ProfileDark.svg'
import ProfileGray from './svg/ProfileGray.svg'
import ProfilePurple from './svg/ProfilePurple.svg'
import ProjectDefault from './svg/ProjectDefault.svg'
import ProjectSelected from './svg/ProjectSelected.svg'
import Properties from './svg/Properties.svg'
import PSD from './svg/PSD.svg'
import Publish from './svg/Publish.svg'
import PublishAsset from './svg/PublishAsset.svg'
import PublishDark from './svg/PublishDark.svg'
import PublishIcon from './svg/PublishIcon.svg'
import PublishQueue from './svg/PublishQueue.svg'
import PublishQueueLarge from './svg/PublishQueueLarge.svg'
import PublishRuleActive from './svg/PublishRuleActive.svg'
import PublishruleLarge from './svg/PublishruleLarge.svg'
import PublishRulesTab from './svg/PublishRulesTab.svg'
import PublishWhite from './svg/PublishWhite.svg'
import PurpleAdd from './svg/PurpleAdd.svg'
import PurpleRemove from './svg/PurpleRemove.svg'
import Quote from './svg/Quote.svg'
import ReadComment from './svg/ReadComment.svg'
import RecurrsSquare from './svg/RecurrsSquare.svg'
import RedAlert from './svg/RedAlert.svg'
import RedeployPurple from './svg/RedeployPurple.svg'
import RedeployWhite from './svg/RedeployWhite.svg'
import Redo from './svg/Redo.svg'
import Reference from './svg/Reference.svg'
import ReferenceSmall from './svg/ReferenceSmall.svg'
import Refresh from './svg/Refresh.svg'
import RefreshCircle from './svg/RefreshCircle.svg'
import RefreshCircleThin from './svg/RefreshCircleThin.svg'
import RefreshEntries from './svg/RefreshEntries.svg'
import RefreshEntriesThin from './svg/RefreshEntriesThin.svg'
import ReleaseModuleLarge from './svg/ReleaseModuleLarge.svg'
import Releases from './svg/Releases.svg'
import ReleasesFilled from './svg/ReleasesFilled.svg'
import Reload from './svg/Reload.svg'
import Remove from './svg/Remove.svg'
import RemoveDanger from './svg/RemoveDanger.svg'
import RemoveFilled from './svg/RemoveFilled.svg'
import RemoveGrey from './svg/RemoveGrey.svg'
import RemoveWhite from './svg/RemoveWhite.svg'
import Rename from './svg/Rename.svg'
import Replace from './svg/Replace.svg'
import Reset from './svg/Reset.svg'
import ResetWhite from './svg/ResetWhite.svg'
import Resize from './svg/Resize.svg'
import RestAlias from './svg/RestAlias.svg'
import RestEnvironments from './svg/RestEnvironments.svg'
import Restore from './svg/Restore.svg'
import RestorePurple from './svg/RestorePurple.svg'
import RestoreThin from './svg/RestoreThin.svg'
import RestoreThinLight from './svg/RestoreThinLight.svg'
import Resume from './svg/Resume.svg'
import Retry from './svg/Retry.svg'
import RetryGray from './svg/RetryGray.svg'
import ReturnLogin from './svg/ReturnLogin.svg'
import RichTextEditor from './svg/RichTextEditor.svg'
import RichTextEditorSmall from './svg/RichTextEditorSmall.svg'
import Right from './svg/Right.svg'
import RightArrow from './svg/RightArrow.svg'
import RightArrowGray from './svg/RightArrowGray.svg'
import RightConnector from './svg/RightConnector.svg'
import RightMark from './svg/RightMark.svg'
import RightMarkActive from './svg/RightMarkActive.svg'
import RightMarkSmall from './svg/RightMarkSmall.svg'
import Rightmost from './svg/Rightmost.svg'
import Rocket from './svg/Rocket.svg'
import RocketLight from './svg/RocketLight.svg'
import Roles from './svg/Roles.svg'
import RTEExtension from './svg/RTEExtension.svg'
import RTF from './svg/RTF.svg'
import Save from './svg/Save.svg'
import SaveWhite from './svg/SaveWhite.svg'
import ScholarHat from './svg/ScholarHat.svg'
import ScholarHatActiveIcon from './svg/ScholarHatActiveIcon.svg'
import SCIMActiveSmall from './svg/SCIMActiveSmall.svg'
import SCIMDefaultSmall from './svg/SCIMDefaultSmall.svg'
import SCIMEmptyState from './svg/SCIMEmptyState.svg'
import Scope from './svg/Scope.svg'
import Search from './svg/Search.svg'
import SearchSmall from './svg/SearchSmall.svg'
import Security from './svg/Security.svg'
import SecurityGray from './svg/SecurityGray.svg'
import SecurityPurple from './svg/SecurityPurple.svg'
import SecurityWhite from './svg/SecurityWhite.svg'
import SeeDetails from './svg/SeeDetails.svg'
import SeeDetailsMedium from './svg/SeeDetailsMedium.svg'
import SeeMore from './svg/SeeMore.svg'
import SeeMoreLarge from './svg/SeeMoreLarge.svg'
import Select from './svg/Select.svg'
import SelectSingle from './svg/SelectSingle.svg'
import SelectSmall from './svg/SelectSmall.svg'
import Send from './svg/Send.svg'
import SendActive from './svg/SendActive.svg'
import ServerSelection from './svg/ServerSelection.svg'
import Setting from './svg/Setting.svg'
import Settings from './svg/Settings.svg'
import SettingsMedium from './svg/SettingsMedium.svg'
import SettingsOutline from './svg/SettingsOutline.svg'
import SingleA from './svg/SingleA.svg'
import SingleCopyIcon from './svg/SingleCopyIcon.svg'
import SingleCopyIconSmall from './svg/SingleCopyIconSmall.svg'
import SingleCT from './svg/SingleCT.svg'
import SingleLineText from './svg/SingleLineText.svg'
import SingleLineTextSmall from './svg/SingleLineTextSmall.svg'
import SmallCancelCircle from './svg/SmallCancelCircle.svg'
import SmallCheckedCircle from './svg/SmallCheckedCircle.svg'
import SocialEmbed from './svg/SocialEmbed.svg'
import SSOFailSmall from './svg/SSOFailSmall.svg'
import SSOFailureVerify from './svg/SSOFailureVerify.svg'
import SsoModuleLarge from './svg/SsoModuleLarge.svg'
import SSOSuccessSmall from './svg/SSOSuccessSmall.svg'
import SSOSuccessVerify from './svg/SSOSuccessVerify.svg'
import Stacks from './svg/Stacks.svg'
import StackSettings from './svg/StackSettings.svg'
import Stage from './svg/Stage.svg'
import Staging from './svg/Staging.svg'
import Star from './svg/Star.svg'
import StarLarge from './svg/StarLarge.svg'
import StarSmall from './svg/StarSmall.svg'
import Status from './svg/Status.svg'
import StatusPage from './svg/StatusPage.svg'
import StrikeThrough from './svg/StrikeThrough.svg'
import SubScript from './svg/Subscript.svg'
import Success from './svg/Success.svg'
import SuccessInverted from './svg/SuccessInverted.svg'
import SuccessTransferOwnership from './svg/SuccessTransferOwnership.svg'
import SuperchargedRte from './svg/SuperchargedRte.svg'
import SuperchargedRteSmall from './svg/SuperchargedRteSmall.svg'
import SuperScript from './svg/Superscript.svg'
import SuperUser from './svg/SuperUser.svg'
import SVG from './svg/SVG.svg'
import Table from './svg/Table.svg'
import TagSmall from './svg/TagSmall.svg'
import Tasks from './svg/Tasks.svg'
import TasksModuleLarge from './svg/TasksModuleLarge.svg'
import TasksSelected from './svg/TasksSelected.svg'
import TeamsDefault from './svg/TeamsDefault.svg'
import TeamsEmptyState from './svg/TeamsEmptyState.svg'
import TeamsOutlineDefault from './svg/TeamsOutlineDefault.svg'
import TestSSOPurple from './svg/TestSSOPurple.svg'
import TestSSOWhite from './svg/TestSSOWhite.svg'
import Thumbnail from './svg/Thumbnail.svg'
import Time from './svg/Time.svg'
import TransferOwnership from './svg/TransferOwnership.svg'
import Trash from './svg/Trash.svg'
import TrashLarge from './svg/TrashLarge.svg'
import TrashMini from './svg/TrashMini.svg'
import TrashModuleLarge from './svg/TrashModuleLarge.svg'
import TrashSmall from './svg/TrashSmall.svg'
import TrashTransparent from './svg/TrashTransparent.svg'
import TriangleArrow from './svg/TriangleArrow.svg'
import TXT from './svg/TXT.svg'
import Uid from './svg/Uid.svg'
import Underline from './svg/Underline.svg'
import Undo from './svg/Undo.svg'
import Unlocalize from './svg/Unlocalize.svg'
import Unpublish from './svg/Unpublish.svg'
import UnpublishAsset from './svg/UnpublishAsset.svg'
import UnpublishAssetWhite from './svg/UnpublishAssetWhite.svg'
import UnPublishDark from './svg/UnPublishDark.svg'
import UnPublishFull from './svg/UnPublishFull.svg'
import UnpublishGrey from './svg/UnpublishGrey.svg'
import UnpublishIcon from './svg/UnpublishIcon.svg'
import Update from './svg/Update.svg'
import Upload from './svg/Upload.svg'
import UploadIcon from './svg/UploadIcon.svg'
import Uploading from './svg/Uploading.svg'
import USA from './svg/US.svg'
import UserPermission from './svg/UserPermission.svg'
import Users from './svg/Users.svg'
import UsersEmptyState from './svg/UsersEmptyState.svg'
import UsersRoles from './svg/UsersRoles.svg'
import VenusAuthorizationFailedLarge from './svg/VenusAuthorizationFailedLarge.svg'
import Version from './svg/Version.svg'
import Versions from './svg/versions.svg'
import VersionsGray from './svg/versionsGray.svg'
import Video2 from './svg/Video2.svg'
import VideoActive from './svg/VideoActive.svg'
import VideoLarge from './svg/VideoLarge.svg'
import VideoMedium from './svg/VideoMedium.svg'
import View from './svg/View.svg'
import ViewWhite from './svg/ViewWhite.svg'
import Warning from './svg/Warning.svg'
import WarningInverted from './svg/WarningInverted.svg'
import WebhookLarge from './svg/WebhookLarge.svg'
import Webhooks from './svg/Webhooks.svg'
import WhatsNew from './svg/WhatsNew.svg'
import Widgets from './svg/Widgets.svg'
import Workflow from './svg/Workflow.svg'
import WorkflowActive from './svg/WorkflowActive.svg'
import WorkflowDetailsTab from './svg/WorkflowDetailsTab.svg'
import WorkflowEmptyState from './svg/WorkflowEmptyState.svg'
import WorkflowLarge from './svg/WorkflowLarge.svg'
import WorkflowModuleLarge from './svg/WorkflowModuleLarge.svg'
import WorkflowsTab from './svg/WorkflowsTab.svg'
import StageIcon from './svg/WorkflowStage.svg'
import WorkflowTabEntry from './svg/WorkflowTabEntry.svg'
import WorkflowWhite from './svg/WorkflowWhite.svg'
import XLS from './svg/XLS.svg'
import XML from './svg/XML.svg'
import YellowStar from './svg/YellowStar.svg'
import ZIP from './svg/ZIP.svg'
import ViewNestedEntries from './svg/ViewNestedEntries.svg'
import ArrowRight from './svg/ArrowRight.svg'
import ArrowRightWhite from './svg/ArrowRightWhite.svg';

import ExpandArrow from './svg/ExpandArrow.svg'
import CollapseArrow from './svg/CollapseArrow.svg'

export const iconComponents = {
  SeeDetails,
  SeeDetailsMedium,
  Paragraph,
  ApiConsole,
  Resize,
  ApiDocs,
  ApiTokens,
  ApiTokensLarge,
  FolderModuleLarge,
  DropdownChevronDark,
  ContentModelsMediumActive,
  GlobalFieldsMediumActive,
  ErrorWhite,
  InfoInvertedWhite,
  SSOFailSmall,
  SSOSuccessSmall,
  SSOSuccessVerify,
  SSOFailureVerify,
  RestAlias,
  YellowStar,
  PublishIcon,
  GreenChecked,
  NewEntry,
  UnpublishIcon,
  GlobalFieldSmall,
  ChevronExtraSmall,
  Restore,
  RestorePurple,
  EntryChatAlert,
  PublishQueueLarge,
  CreateWhite,
  ForwardWhite,
  ExtensionPurple,
  Send,
  SendActive,
  FolderMedium,
  AudioMedium,
  StarSmall,
  ApiDoc,
  ChatSupport,
  ChatSupportActive,
  Feedback,
  HelpCentre,
  HelpExtraLarge,
  HelpExtraLargeActive,
  HelpExtraLargeNotification,
  SuccessTransferOwnership,
  FailTransferOwnership,
  KeyboardShortcut,
  ProductTour,
  LearnMore,
  StatusPage,
  WhatsNew,
  ChangeVersion,
  NotificationActive,
  FullScreenMode,
  InviteUser,
  NotificationAlert,
  ContentModelsMedium,
  GlobalFieldsMedium,
  Update,
  CodeSecondary,
  NotificationAtRest,
  NotificationModuleLarge,
  CancelPurple,
  DiscussionModuleLarge,
  RemoveDanger,
  RemoveFilled,
  RemoveWhite,
  Docs,
  CopyIconSmall,
  ProceedActive,
  ViewWhite,
  InfoSecondary,
  Audit,
  Display,
  Releases,
  Disk,
  CodeMedium,
  PublishRuleActive,
  WorkflowActive,
  Env,
  Extension,
  ExtensionLarge,
  Language,
  SearchSmall,
  ImageActive,
  VideoActive,
  ExecutableActive,
  MinusSign,
  CancelLarge,
  Delivery,
  ArchiveActive,
  CheckedWhite,
  CheckedPurple,
  Stacks,
  AudioActive,
  DownArrow,
  ArrowUp,
  ArrowDown,
  CodeActive,
  DocumentActive,
  View,
  NewTab,
  StackSettings,
  UsersRoles,
  Workflow,
  Webhooks,
  WebhookLarge,
  Preferences,
  HelpLarge,
  PublishQueue,
  Chat,
  AssetSelected,
  Pin,
  DeliveryActive,
  Management,
  ManagementActive,
  ChatSelected,
  ContentModelSelected,
  TasksSelected,
  SmallCancelCircle,
  SmallCheckedCircle,
  SecurityPurple,
  SecurityWhite,
  InformationSmallPurple,
  InformationSmall,
  Copy,
  CopyWhite,
  LeaveStackWhite,
  ProfilePurple,
  InfoSmall,
  Rename,
  Setting,
  TestSSOWhite,
  TestSSOPurple,
  Compare,
  Thumbnail,
  List,
  Entries,
  Tasks,
  AssetImage,
  Audio,
  Video,
  Document,
  Folder,
  Executable,
  Code,
  Archive,
  MoveSmall,
  Dropdown,
  DownArrowDisabled,
  DisableDark,
  DisableLarge,
  DownArrowEnabled,
  SelectSingle,
  Dashboard,
  ChevronDown,
  ChevronRight,
  Logo,
  Left,
  Leftmost,
  LeftConnector,
  IconCopy,
  Filter,
  Layout,
  Intercom,
  GridView,
  HelpDocs,
  OrgSettings,
  Right,
  Rightmost,
  RightArrow,
  RightConnector,
  Search,
  PublishDark,
  UnPublishDark,
  Settings,
  Publish,
  Star,
  DarkStar,
  StarLarge,
  ErrorCircle,
  Warning,
  Error,
  AddPlusBold,
  Info,
  Success,
  CheckboxActive,
  CheckboxDisabled,
  CheckboxInactive,
  Checked,
  ActiveRectangle,
  Cancel,
  CancelSec,
  Delete,
  GroupField,
  PageNotFoundError,
  PageConstructionError,
  LoginError,
  Staging,
  Production,
  Development,
  RestEnvironments,
  EnvironmentsLarge,
  Hamburger,
  NewFolder,
  ChangeView,
  AssetFullScreen,
  AssetZoom,
  Save,
  SaveWhite,
  UnpublishAsset,
  UnpublishAssetWhite,
  UnPublishFull,
  PublishAsset,
  PublishWhite,
  ImageAssetFullscreen,
  Expand,
  Compress,
  Version,
  SingleCopyIcon,
  Refresh,
  ColumnSelector,
  Edit,
  Trash,
  TrashMini,
  BackArrow,
  ComfortView,
  CompactView,
  MoveIcon,
  Boolean,
  Custom,
  Date,
  File,
  Global,
  Group,
  Link,
  LinkWhite,
  Markdown,
  ModularBlocks,
  MultiLineText,
  Number,
  Reference,
  RichTextEditor,
  AuditlogLarge,
  Select,
  SingleLineText,
  SingleLineTextSmall,
  MultiLineTextSmall,
  RichTextEditorSmall,
  TagSmall,
  MarkdownSmall,
  SelectSmall,
  ModularBlocksSmall,
  NumberSmall,
  BooleanSmall,
  DateSmall,
  FileSmall,
  LinkSmall,
  ReferenceSmall,
  GroupSmall,
  GlobalSmall,
  CustomSmall,
  Add,
  PurpleAdd,
  Remove,
  PurpleRemove,
  PlusSign,
  SingleA,
  DefaultEnv,
  Widgets,
  Podium,
  Contains,
  SecurityGray,
  ProfileGray,
  Equals,
  NotEquals,
  DropdownDark,
  Clock,
  Enable,
  Plus,
  Minus,
  PlusBold,
  DeleteTransparent,
  InfoCircle,
  InfoCircleWhite,
  SuccessInverted,
  WarningInverted,
  ErrorInverted,
  Bullet,
  SeeMore,
  AddCircle,
  CancelCircle,
  CheckedCircle,
  LeftArrow,
  TriangleArrow,
  ActionBar,
  TrashTransparent,
  NotPublish,
  LeftArrowGray,
  RightArrowGray,
  Bin,
  ContentStack,
  SeeMoreLarge,
  Lock,
  LockSmall,
  Unpublish,
  ReleasesFilled,
  Import,
  ImportActive,
  ImportWhite,
  Export,
  ExportActive,
  HalfHeart,
  LightBulb,
  Close,
  Status,
  Information,
  ChevronUp,
  DeleteAsset,
  EditTransparent,
  MoveTo,
  Move,
  DeleteTransparentLarge,
  Pause,
  Uploading,
  CancelTransparent,
  ChevronUpTransparent,
  Resume,
  ChevronDownTransparent,
  Reload,
  CheckedTransparent,
  Email,
  EmailWhite,
  ChevronSmall,
  TrashSmall,
  Unlocalize,
  VideoMedium,
  ArchiveMedium,
  DocumentMedium,
  Bulb,
  Roles,
  Invitation,
  Assets,
  ContentModels,
  Users,
  CustomWidget,
  CustomField,
  RTEExtension,
  DashboardWidget,
  DisableGray,
  Replace,
  DeployDisabled,
  DeployActive,
  DeployOutline,
  DeployDefault,
  Deploy,
  Analytics,
  SocialEmbed,

  Html,
  Undo,
  Redo,
  Quote,
  Code2,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Bold,
  Underline,
  Italic,
  StrikeThrough,
  SuperScript,
  SubScript,
  List2,
  Alignment,
  HelpSmall,
  PlusPurple,

  Video2,
  Image,
  Table,
  Link2,
  Properties,

  Check,
  ModifiedBy,
  PersonalizationLogo,
  PersonalizationLogoGrey,
  PersonalizationLogoGreySmall,
  PersonalizationAttributes,
  PersonalizationAttributesActive,
  PersonalizationAudiences,
  PersonalizationAudiencesActive,
  PersonalizationExperiences,
  PersonalizationExperiencesActive,
  PersonalizationVariations,
  FolderOpen,
  Help,
  VideoLarge,
  PdfLarge,
  Pdf,
  ImageLarge,
  DocumentLarge,
  AudioLarge,
  ArchiveLarge,
  ApkLarge,
  FolderLarge,
  CodeLarge,
  Download,
  AddCircleLarge,
  Automation,
  Versions,
  VersionsGray,
  Key,
  LeaveStack,
  ExperienceContainer,
  ExperienceContainerPink,
  DoubleArrow,
  DeleteQueryBuilder,
  AddQueryBuilder,
  RightMark,
  RightMarkActive,
  Disable,
  OnPower,
  OnPowerWhite,
  Profile,
  Security,
  Uid,
  Retry,

  ReadComment,
  NewComment,
  RetryGray,
  ProjectDefault,
  ProjectSelected,

  EditSmall,
  EditSmallActive,
  DuplicateSmall,
  DeleteSmall,
  LessThanEquals,
  GreaterThanEquals,

  CTModuleLarge,
  EntryModuleLarge,
  GFModuleLarge,
  AssetModuleLarge,
  ReleaseModuleLarge,
  TasksModuleLarge,
  CSLogoLarge,
  StageIcon,
  InfoLight,
  GlobalFields,
  WorkflowLarge,
  EntryComment,
  USA,
  EUROPE,
  WorkflowsTab,
  WorkflowTabEntry,
  SingleCT,
  MultiCT,
  SingleCopyIconSmall,
  EnableGray,
  PublishRulesTab,
  EntryChat,
  AddPlus,
  ManageWidget,
  ActivateAccount,
  TransferOwnership,
  MoveHere,
  Upload,
  Proceed,
  ForgotPassword,
  ReturnLogin,
  Login,
  NoCommentBanner,
  RightMarkSmall,
  ServerSelection,
  Reset,
  ResetWhite,
  DontSave,
  DashboardModuleLarge,
  ManageWidgetsLarge,
  LessThan,
  GreaterThan,
  EnvironmentColor,
  PersonalizationExperiencesLarge,
  PersonalizationAudiencesLarge,
  PersonalizationAttributesLarge,
  PageNotFound,

  VenusAuthorizationFailedLarge,
  CSLogo,
  Eye,
  UserPermission,
  GroupPermission,
  EyeClose,
  OpenLock,
  OpenLockDisabled,
  TrashModuleLarge,
  TrashLarge,
  PublishruleLarge,

  WorkflowModuleLarge,

  InformationWithDot,
  SsoModuleLarge,
  ExtensionModuleLarge,
  SCIMEmptyState,
  SCIMDefaultSmall,
  SCIMActiveSmall,

  TeamsEmptyState,
  TeamsDefault,
  TeamsOutlineDefault,
  UsersEmptyState,

  AnalyticsDashboardModuleLarge,
  NewTabLight,
  AddPlusGrey,
  ModuleError,
  LivePreview,
  ClockDark,
  ProfileDark,
  Embed,
  SuperchargedRte,
  SuperchargedRteSmall,
  LanguageDark,
  WorkflowWhite,

  SettingsOutline,
  BulkTaskQueue,
  BulkTaskLarge,

  Forward,
  Backward,
  Maximize,
  Minimize,
  PopoutClose,
  EntryStructureOutline,
  UnpublishGrey,

  HTML2,
  PDF2,
  DOC2,
  MP4,
  MP3,
  JS,
  JSON,
  ZIP,
  EXE,
  RTF,
  XML,
  TXT,
  PPT,
  CSV,
  XLS,
  AVI,
  AI,
  JPG,
  PNG,
  PSD,
  SVG,
  BranchIcon,
  AliasIcon,
  CSS,

  GitBranch,
  Time,
  CreatedAt,
  ContentFlyEnvironments,
  ContentFlyEnvironmentsActive,
  ContentFlyEnvironmentsFilled,
  GlobeWithCursor,
  GlobeWithCursorActive,
  RedeployPurple,
  RedeployWhite,
  DeploymentFilled,

  WorkflowDetailsTab,
  WorkflowEmptyState,

  EqualToSquare,
  NotEqualToSquare,
  ContainsSquare,
  DoesNotContainsSquare,
  HasAnyValueSquare,
  HasNoValueSquare,
  IsTrueSquare,
  IsFalseSquare,
  LessThanSquare,
  GreaterThanSquare,
  SettingsMedium,
  OngoingTask,
  CompletedTask,
  Alias,
  BranchActive,
  AliasActive,
  Branch,
  GlobalFieldSelectedSmall,
  CopyUrl,
  CopyUrlTiny,
  AliasName,
  BranchTree,
  BranchIcon2,
  Information2,
  AliasLarge,
  Asset,
  Bucket,
  Rocket,
  BucketLight,
  RocketLight,
  CellNetwork,
  Pie,
  Bandwidth,
  ApiCalls,
  BranchSetting,
  HoverAlias,
  ClickAlias,
  NoBranch,
  RedAlert,
  BranchLarge,
  MarketplaceSmallFilled,
  MarketplaceSmallFilledWhite,
  ContentStackRedLogo,
  MarketplaceSmallFilledGray,
  Marketplace,
  ExtensionPurpleCircle,
  ExtensionSmallFilled,
  ABTesting,
  ABTestingAnalytics,
  ABTestingMetrics,
  ABTestingTargeting,
  AudienceExperience,
  AndDark,
  ScholarHat,
  ScholarHatActiveIcon,
  UploadIcon,
  RefreshCircleThin,
  RefreshCircle,
  InfoGreen,
  InfoYellow,
  PersonalizationEvents,
  PersonalizationEventsActive,
  PersonalizationEventsLarge,
  GreyAdd,
  ViewNestedEntries,
  PlusGreySmall,
  MinusGreySmall,
  BackArrowSquare,
  ArrowSquare,
  DoubleArrowSquare,
  RecurrsSquare,
  RefreshEntries,
  RefreshEntriesThin,
  Description,
  Scope,
  Stage,
  SuperUser,
  Activation,
  CancelMedium,
  CancelSmall,
  RestoreThin,
  RestoreThinLight,
  RemoveGrey,
  ArrowRight,
  ArrowRightWhite,
  ExpandArrow,
  CollapseArrow
}

export const iconName = {
  LivePreview: 'LivePreview',
  SeeDetails: 'SeeDetails',
  SeeDetailsMedium: 'SeeDetailsMedium',
  Paragraph: 'Paragraph',
  ApiConsole: 'ApiConsole',
  ApiDocs: 'ApiDocs',
  ApiTokens: 'ApiTokens',
  ApiTokensLarge: 'ApiTokensLarge',
  Audit: 'Audit',
  Display: 'Display',
  NotificationModuleLarge: 'NotificationModuleLarge',
  NotificationActive: 'NotificationActive',
  NotificationAlert: 'NotificationAlert',
  NotificationAtRest: 'NotificationAtRest',
  InfoSecondary: 'InfoSecondary',
  Releases: 'Releases',
  Env: 'Env',
  Rename: 'Rename',
  Extension: 'Extension',
  ExtensionLarge: 'ExtensionLarge',
  InfoSmall: 'InfoSmall',
  View: 'View',
  Language: 'Language',
  ErrorWhite: ' ErrorWhite',
  InfoInvertedWhite: 'InfoInvertedWhite',
  YellowStar: 'YellowStar',
  NewEntry: 'NewEntry',
  Stacks: 'Stacks',
  NewTab: 'Newtab',
  Resize: 'Resize',
  MinusSign: 'MinusSign',
  ApiDoc: 'ApiDoc',
  ChatSupport: 'ChatSupport',
  ChatSupportActive: 'ChatSupportActive',
  GlobalFieldSmall: 'GlobalFieldSmall',
  ChevronExtraSmall: 'ChevronExtraSmall',
  Feedback: 'Feedback',
  HelpCentre: 'HelpCentre',
  Send: 'Send',
  Restore: 'Restore',
  RestorePurple: 'RestorePurple',
  EntryChatAlert: 'EntryChatAlert',
  RestAlias: 'RestAlias',
  Pin: 'Pin',
  SendActive: 'SendActive',
  HelpExtraLarge: 'HelpExtraLarge',
  HelpExtraLargeActive: 'HelpExtraLargeActive',
  HelpExtraLargeNotification: 'HelpExtraLargeNotification',
  Update: 'Update',
  WhatsNew: 'WhatsNew',
  StatusPage: 'StatusPage',
  ProductTour: 'ProductTour',
  KeyboardShortcut: 'KeyboardShortcut',
  CreateWhite: 'CreateWhite',
  Docs: 'Docs',
  DownArrow: 'DownArrow',
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  CodeSecondary: 'CodeSecondary',
  SuccessTransferOwnership: 'SuccessTransferOwnership',
  FailTransferOwnership: 'FailTransferOwnership',
  CancelPurple: 'CancelPurple',
  AuditlogLarge: 'AuditlogLarge',
  GreenChecked: 'GreenChecked',
  Disk: 'Disk',
  Chat: 'Chat',
  ViewWhite: 'ViewWhite',
  SSOSuccessSmall: 'SSOSuccessSmall',
  SSOFailSmall: 'SSOFailSmall',
  SSOSuccessVerify: 'SSOSuccessVerify',
  SSOFailureVerify: 'SSOFailureVerify',
  ChangeVersion: 'ChangeVersion',
  GlobalFieldsMedium: 'GlobalFieldsMedium',
  ContentStackRedLogo: 'ContentStackRedLogo',
  Setting: 'Setting',
  DropdownChevronDark: 'DropdownChevronDark',
  ImageActive: 'ImageActive',
  CopyIconSmall: 'CopyIconSmall',
  PublishQueueLarge: 'PublishQueueLarge',
  Delivery: 'Delivery',
  DocumentActive: 'DocumentActive',
  ExecutableActive: 'ExceutableActive',
  RemoveDanger: 'RemoveDanger',
  RemoveFilled: 'RemoveFilled',
  ContentModelsMedium: 'ContentModelsMedium',
  ContentModelsMediumActive: 'ContentModelsMediumActive',
  GlobalFieldsMediumActive: 'GlobalFieldsMediumActive',
  RemoveWhite: 'RemoveWhite',
  CodeMedium: 'CodeMedium',
  AudioActive: 'AudioActive',
  VideoActive: 'VideoActive',
  StarSmall: 'StarSmall',
  StarLarge: 'StarLarge',
  CancelLarge: 'CancelLarge',
  ArchiveActive: 'ArchiveActive',
  DiscussionModuleLarge: 'DiscussionModuleLarge',
  CodeActive: 'CodeActive',
  SearchSmall: 'SearchSmall',
  Assets: 'Assets',
  FolderModuleLarge: 'FolderModuleLarge',
  ContentModels: 'ContentModels',
  LearnMore: 'LearnMore',
  StackSettings: 'StackSettings',
  PublishRuleActive: ' PublishRuleActive',
  WorkflowActive: 'WorkflowActive',
  UsersRoles: 'UsersRoles',
  Workflow: 'Workflows',
  HelpLarge: 'HelpLarge',
  Webhooks: 'Webhooks',
  WebhookLarge: 'WebhookLarge',
  Compare: 'Compare',
  CheckedWhite: 'CheckedWhite',
  MoveSmall: 'MoveSmall',
  CheckedPurple: 'CheckedPurple',
  InviteUser: ' InviteUser',
  AssetSelected: 'AssetSelected',
  ChatSelected: 'ChatSelected',
  SmallCheckedCircle: 'SmallCheckedCircle',
  SmallCancelCircle: 'SmallCancelCircle',
  ContentModelSelected: 'ContentModelSelected',
  TasksSelected: 'TasksSelected',
  TestSSOWhite: 'TestSSOWhite',
  LeaveStackWhite: 'LeaveStackWhite',
  TestSSOPurple: 'TestSSOPurple',
  Preferences: 'Preferences',
  ProceedActive: 'ProceedActive',
  PublishQueue: 'PublishQueue',
  Dropdown: 'Dropdown',
  DeliveryActive: 'DeliveryActive',
  Management: 'Management',
  ManagementActive: 'ManagementActive',
  ChevronDown: 'ChevronDown',
  ChevronRight: 'ChevronRight',
  Filter: 'Filter',
  Enable: 'Enable',
  InformationSmallPurple: 'InformationSmallPurple',
  Search: 'Search',
  DeployDisabled: 'DeployDisabled',
  DeployActive: 'DeployActive',
  DeployOutline: 'DeployOutline',
  DeployDefault: 'DeployDefault',
  Deploy: 'Deploy',
  Settings: 'Settings',
  InformationSmall: 'InformationSmall',
  Copy: 'Copy',
  CopyWhite: 'CopyWhite',
  Logo: 'Logo',
  PlusPurple: 'PlusPurple',
  Left: 'Left',
  Leftmost: 'Leftmost',
  LeftConnector: 'LeftConnector',
  Right: 'Right',
  Rightmost: 'Rightmost',
  RightArrow: 'RightArrow',
  RightConnector: 'RightConnector',
  GridView: 'GridView',
  Intercom: 'Intercom',
  OrgSettings: 'OrgSettings',
  Star: 'Star',
  PublishIcon: 'PublishIcon',
  UnpublishIcon: 'UnpublishIcon',
  DarkStar: 'DarkStar',
  Publish: 'Publish',
  PublishWhite: 'PublishWhite',
  Widgets: 'Widgets',
  Podium: 'Podium',
  DownArrowDisabled: 'DownArrowDisabled',
  DisableDark: 'DisableDark',
  DisableLarge: 'DisableLarge',
  DownArrowEnabled: 'DownArrowEnabled',
  IconCopy: 'IconCopy',
  Layout: 'Layout',
  ErrorCircle: 'ErrorCircle',
  HelpDocs: 'HelpDocs',
  Info: 'Info',
  Success: 'Success',
  SecurityPurple: 'SecurityPurple',
  SecurityWhite: 'SecurityWhite',
  ProfilePurple: 'ProfilePurple',
  Error: 'Error',
  CheckboxActive: 'CheckboxActive',
  CheckboxDisabled: 'CheckboxDisabled',
  CheckboxInactive: 'CheckboxInactive',
  Checked: 'Checked',
  ActiveRectangle: 'ActiveRectangle',
  Cancel: 'Cancel',
  CancelSec: 'CancelSec',
  Delete: 'Delete',
  GroupField: 'GroupField',
  PageNotFoundError: 'PageNotFoundError',
  PageConstructionError: 'PageConstructionError',
  LoginError: 'LoginError',
  Staging: 'Staging',
  Production: 'Production',
  Development: 'Development',
  RestEnvironments: 'RestEnvironments',
  EnvironmentsLarge: 'EnvironmentsLarge',
  Hamburger: 'Hamburger',
  NewFolder: 'NewFolder',
  ChangeView: 'ChangeView',
  AssetZoom: 'AssetZoom',
  AssetFullScreen: 'AssetFullScreen',
  Save: 'Save',
  UnpublishAsset: 'UnpublishAsset',
  PublishDark: 'PublishDark',
  UnPublishDark: 'UnPublishDark',
  UnPublishFull: 'UnPublishFull',
  PublishAsset: 'PublishAsset',
  ImageAssetFullscreen: 'ImageAssetFullscreen',
  Expand: 'Expand',
  Compress: 'Compress',
  Version: 'Version',
  AssetImage: 'AssetImage',
  Folder: 'Folder',
  Audio: 'Audio',
  Video: 'Video',
  Code: 'Code',
  Executable: 'Executable',
  Document: 'Document',
  Archive: 'Archive',
  SingleCopyIcon: 'SingleCopyIcon',
  Refresh: 'Refresh',
  Thumbnail: 'Thumbnail',
  List: 'List',
  MoveIcon: 'MoveIcon',
  EditTransparent: 'EditTransparent',
  DeleteAsset: 'DeleteAsset',
  MoveTo: 'MoveTo',
  Move: 'Move',
  DeleteTransparentLarge: 'DeleteTransparentLarge',
  Bulb: 'Bulb',
  Roles: 'Roles',
  Invitation: 'Invitation',
  SelectSingle: 'SelectSingle',
  HelpSmall: 'HelpSmall',
  Users: 'Users',
  Replace: 'Replace',
  SecurityGray: 'SecurityGray',
  ProfileGray: 'ProfileGray',

  Dashboard: 'Dashboard',
  Entries: 'Entries',
  Tasks: 'Tasks',
  ColumnSelector: 'ColumnSelector',
  Edit: 'Edit',
  Trash: 'Trash',
  TrashMini: 'TrashMini',
  BackArrow: 'BackArrow',
  ComfortView: 'ComfortView',
  CompactView: 'CompactView',
  Boolean: 'Boolean',
  Custom: 'Custom',
  Date: 'Date',
  File: 'File',
  Global: 'Global',
  Group: 'Group',
  Link: 'Link',
  LinkWhite: 'LinkWhite',
  Markdown: 'Markdown',
  ModularBlocks: 'ModularBlocks',
  MultiLineText: 'MultiLineText',
  Number: 'Number',
  Reference: 'Reference',
  RichTextEditor: 'RichTextEditor',
  Select: 'Select',
  SingleLineText: 'SingleLineText',
  SingleLineTextSmall: 'SingleLineTextSmall',
  MultiLineTextSmall: 'MultiLineTextSmall',
  RichTextEditorSmall: 'RichTextEditorSmall',
  MarkdownSmall: 'MarkdownSmall',
  SelectSmall: 'SelectSmall',
  ModularBlocksSmall: 'ModularBlocksSmall',
  NumberSmall: 'NumberSmall',
  BooleanSmall: 'BooleanSmall',
  SocialEmbed: 'SocialEmbed',
  DateSmall: 'DateSmall',
  FileSmall: 'FileSmall',
  LinkSmall: 'LinkSmall',
  ReferenceSmall: 'ReferenceSmall',
  TagSmall: 'TagSmall',
  GroupSmall: 'GroupSmall',
  GlobalSmall: 'GlobalSmall',
  CustomSmall: 'CustomSmall',
  Add: 'Add',
  PurpleAdd: 'PurpleAdd',
  Remove: 'Remove',
  PurpleRemove: 'PurpleRemove',
  PlusSign: 'PlusSign',
  SingleA: 'SingleA',
  DefaultEnv: 'DefaultEnv',
  Contains: 'Contains',
  Equals: 'Equals',
  NotEquals: 'NotEquals',
  DropdownDark: 'DropdownDark',
  Clock: 'Clock',
  Plus: 'Plus',
  Minus: 'Minus',
  PlusBold: 'PlusBold',
  DeleteTransparent: 'DeleteTransparent',
  InfoCircle: 'InfoCircle',
  InfoCircleWhite: 'InfoCircleWhite',
  SuccessInverted: 'SuccessInverted',
  WarningInverted: 'WarningInverted',
  Warning: 'Warning',
  ErrorInverted: 'ErrorInverted',
  Bullet: 'Bullet',
  SeeMore: 'SeeMore',
  AddCircle: 'AddCircle',
  CancelCircle: 'CancelCircle',
  CheckedCircle: 'CheckedCircle',
  LeftArrow: 'LeftArrow',
  TriangleArrow: 'TriangleArrow',
  ActionBar: 'ActionBar',
  TrashTransparent: 'TrashTransparent',
  NotPublish: 'NotPublish',
  LeftArrowGray: 'LeftArrowGray',
  RightArrowGray: 'RightArrowGray',
  Bin: 'Bin',
  ContentStack: 'ContentStack',
  SeeMoreLarge: 'SeeMoreLarge',
  Unpublish: 'Unpublish',
  UnpublishAssetWhite: 'UnpublishAssetWhite',
  ReleasesFilled: 'ReleasesFilled',
  Import: 'Import',
  AddPlusBold: 'AddPlusBold',
  ImportActive: 'ImportActive',
  ImportWhite: 'ImportWhite',
  Export: 'Export',
  ExportActive: 'ExportActive',
  Lock: 'Lock',
  LockSmall: 'LockSmall',
  HalfHeart: 'HalfHeart',
  LightBulb: 'LightBulb',
  Close: 'Close',
  Status: 'Status',
  Information: 'Information',
  ChevronUp: 'ChevronUp',
  Pause: 'Pause',
  Uploading: 'Uploading',
  TrashSmall: 'TrashSmall',
  Unlocalize: 'Unlocalize',
  DocumentMedium: 'DocumentMedium',
  VideoMedium: 'VideoMedium',
  ArchiveMedium: 'ArchiveMedium',
  ForwardWhite: 'ForwardWhite',
  ExtensionPurple: 'ExtensionPurple',

  Html: 'Html',
  Undo: 'Undo',
  Redo: 'Redo',
  Quote: 'Quote',
  Code2: 'Code2',
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6',
  Bold: 'Bold',
  Underline: 'Underline',
  Italic: 'Italic',
  StrikeThrough: 'StrikeThrough',
  SuperScript: 'SuperScript',
  SubScript: 'SubScript',
  List2: 'List2',
  Alignment: 'Alignment',

  Video2: 'Video2',
  Image: 'Image',
  Table: 'Table',
  Link2: 'Link2',
  Properties: 'Properties',

  ProjectDefault: 'ProjectDefault',
  ProjectSelected: 'ProjectSelected',

  Check: 'Check',
  ModifiedBy: 'ModifiedBy',
  PersonalizationLogo: 'PersonalizationLogo',
  PersonalizationLogoGrey: 'PersonalizationLogoGrey',
  PersonalizationLogoGreySmall: 'PersonalizationLogoGreySmall',
  PersonalizationAttributes: 'PersonalizationAttributes',
  PersonalizationAttributesActive: 'PersonalizationAttributesActive',
  PersonalizationAudiences: 'PersonalizationAudiences',
  PersonalizationAudiencesActive: 'PersonalizationAudiencesActive',
  PersonalizationExperiences: 'PersonalizationExperiences',
  PersonalizationVariations: 'PersonalizationVariations',
  PersonalizationExperiencesActive: 'PersonalizationExperiencesActive',
  FolderOpen: 'FolderOpen',
  Help: 'Help',
  VideoLarge: 'VideoLarge',
  PdfLarge: 'PdfLarge',
  Pdf: 'Pdf',
  ImageLarge: 'ImageLarge',
  FolderMedium: 'FolderMedium',
  AudioMedium: 'AudioMedium',
  DocumentLarge: 'DocumentLarge',
  AudioLarge: 'AudioLarge',
  ArchiveLarge: 'ArchiveLarge',
  ApkLarge: 'ApkLarge',
  FolderLarge: 'FolderLarge',
  CodeLarge: 'CodeLarge',
  Download: 'Download',
  AddCircleLarge: ' AddCircleLarge',
  Automation: 'Automation',
  Versions: 'Versions',
  VersionsGray: 'VersionsGray',
  CancelTransparent: 'CancelTransparent',
  ChevronUpTransparent: 'ChevronUpTransparent',
  Resume: 'Resume',
  ChevronDownTransparent: 'ChevronDownTransparent',
  Reload: 'Reload',
  Email: 'Email',
  EmailWhite: 'EmailWhite',
  CheckedTransparent: 'CheckedTransparent',
  Key: 'Key',
  LeaveStack: 'LeaveStack',
  ExperienceContainer: 'ExperienceContainer',
  ExperienceContainerPink: 'ExperienceContainerPink',
  DoubleArrow: 'DoubleArrow',
  ChevronSmall: 'ChevronSmall',
  DeleteQueryBuilder: 'DeleteQueryBuilder',
  AddQueryBuilder: 'DeleteQueryBuilder',
  RightMark: 'RightMark',
  RightMarkActive: 'RightMarkActive',
  Disable: 'Disable',
  OnPower: 'OnPower',
  OnPowerWhite: 'OnPowerWhite',
  Profile: 'Profile',
  Security: 'Security',
  Uid: 'Uid',
  DisableGray: 'DisableGray',
  CustomField: 'CustomField',
  RTEExtension: 'RTEExtension',
  CustomWidget: 'CustomWidget',
  DashboardWidget: 'DashboardWidget',
  Retry: 'Retry',
  Analytics: 'Analytics',

  ReadComment: 'ReadComment',
  NewComment: 'NewComment',
  RetryGray: 'RetryGray',

  EditSmall: 'EditSmall',
  EditSmallActive: 'EditSmallActive',
  DuplicateSmall: 'DuplicateSmall',
  DeleteSmall: 'DeleteSmall',
  LessThanEquals: 'LessThanEquals',
  GreaterThanEquals: 'GreaterThanEquals',
  PublishruleLarge: 'PublishruleLarge',
  TrashLarge: 'TrashLarge',
  CTModuleLarge: 'CTModuleLarge',
  EntryModuleLarge: 'EntryModuleLarge',
  GFModuleLarge: 'GFModuleLarge',
  AssetModuleLarge: 'AssetModuleLarge',
  ReleaseModuleLarge: 'ReleaseModuleLarge',
  TasksModuleLarge: 'TasksModuleLarge',
  CSLogoLarge: 'CSLogoLarge',
  StageIcon: 'StageIcon',
  InfoLight: 'InfoLight',
  GlobalFields: 'GlobalFields',
  WorkflowLarge: 'WorkflowLarge',
  EntryComment: 'EntryComment',
  USA: 'USA',
  EUROPE: 'EUROPE',
  WorkflowsTab: 'WorkflowsTab',
  WorkflowTabEntry: 'WorkflowTabEntry',
  SingleCT: 'SingleCT',
  MultiCT: 'MultiCT',
  SingleCopyIconSmall: 'SingleCopyIconSmall',
  EnableGray: 'EnableGray',
  PublishRulesTab: 'PublishRulesTab',
  EntryChat: 'EntryChat',
  AddPlus: 'AddPlus',
  ManageWidget: 'ManageWidget',
  ActivateAccount: 'ActivateAccount',
  TransferOwnership: 'TransferOwnership',
  MoveHere: 'MoveHere',
  Upload: 'Upload',
  Proceed: 'Proceed',
  ForgotPassword: 'ForgotPassword',
  ReturnLogin: 'ReturnLogin',
  Login: 'Login',
  NoCommentBanner: 'NoCommentBanner',
  RightMarkSmall: 'RightMarkSmall',
  ServerSelection: 'ServerSelection',
  Reset: 'Reset',
  ResetWhite: 'ResetWhite',
  DontSave: 'DontSave',
  ManageWidgetsLarge: 'ManageWidgetsLarge',
  DashboardModuleLarge: 'DashboardModuleLarge',
  LessThan: 'LessThan',
  GreaterThan: 'GreaterThan',
  EnvironmentColor: 'EnvironmentColor',
  PersonalizationExperiencesLarge: 'PersonalizationExperiencesLarge',
  PersonalizationAudiencesLarge: 'PersonalizationAudiencesLarge',
  PersonalizationAttributesLarge: 'PersonalizationAttributesLarge',
  PageNotFound: 'PageNotFound',
  SaveWhite: 'SaveWhite',
  VenusAuthorizationFailedLarge: 'VenusAuthorizationFailedLarge',
  CSLogo: 'CSLogo',
  Eye: 'Eye',
  UserPermission: 'UserPermission',
  GroupPermission: 'GroupPermission',
  EyeClose: 'EyeClose',
  OpenLock: 'OpenLock',
  OpenLockDisabled: 'OpenLockDisabled',
  TrashModuleLarge: 'TrashModuleLarge',
  WorkflowModuleLarge: 'WorkflowModuleLarge',
  InformationWithDot: 'InformationWithDot',
  SsoModuleLarge: 'SsoModuleLarge',
  ExtensionModuleLarge: 'ExtensionModuleLarge',
  SCIMEmptyState: 'SCIMEmptyState',
  SCIMDefaultSmall: 'SCIMDefaultSmall',
  SCIMActiveSmall: 'SCIMActiveSmall',
  TeamsEmptyState: 'TeamsEmptyState',
  TeamsDefault: 'TeamsDefault',
  TeamsOutlineDefault: 'TeamsOutlineDefault',
  UsersEmptyState: 'UsersEmptyState',
  AnalyticsDashboardModuleLarge: 'AnalyticsDashboardModuleLarge',
  NewTabLight: 'NewTabLight',
  AddPlusGrey: 'AddPlusGrey',
  ModuleError: 'ModuleError',
  ClockDark: 'ClockDark',
  ProfileDark: 'ProfileDark',
  FullScreenMode: 'FullScreenMode',
  Embed: 'Embed',
  SuperchargedRte: 'SuperchargedRte',
  SuperchargedRteSmall: 'SuperchargedRteSmall',
  LanguageDark: 'LanguageDark',
  WorkflowWhite: 'WorkflowWhite',

  SettingsOutline: 'SettingsOutline',
  BulkTaskQueue: 'BulkTaskQueue',
  BulkTaskLarge: 'BulkTaskLarge',

  Forward: "Forward",
  Backward: "Backward",
  Maximize: "Maximize",
  Minimize: "Minimize",
  PopoutClose: "PopoutClose",
  EntryStructureOutline: "EntryStructureOutline",
  UnpublishGrey: 'UnpublishGrey',

  HTML2: 'HTML2',
  PDF2: 'PDF2',
  DOC2: 'DOC2',
  MP4: 'MP4',
  MP3: 'MP3',
  JS: 'JS',
  JSON: 'JSON',
  ZIP: 'ZIP',
  EXE: 'EXE',
  RTF: 'RTF',
  XML: 'XML',
  TXT: 'TXT',
  PPT: 'PPT',
  CSV: 'CSV',
  XLS: 'XLS',
  AVI: 'AVI',
  AI: 'AI',
  JPG: 'JPG',
  PNG: 'PNG',
  PSD: 'PSD',
  SVG: 'SVG',
  BranchIcon: 'BranchIcon',
  AliasIcon: 'AliasIcon',
  CSS: 'CSS',

  GitBranch: 'GitBranch',
  Time: 'Time',
  CreatedAt: 'CreatedAt',
  ContentFlyEnvironments: 'ContentFlyEnvironments',
  ContentFlyEnvironmentsActive: 'ContentFlyEnvironmentsActive',
  ContentFlyEnvironmentsFilled: 'ContentFlyEnvironmentsFilled',
  GlobeWithCursor: 'GlobeWithCursor',
  GlobeWithCursorActive: 'GlobeWithCursorActive',
  RedeployPurple: 'RedeployPurple',
  RedeployWhite: 'RedeployWhite',
  DeploymentFilled: 'DeploymentFilled',

  WorkflowDetailsTab: 'WorkflowDetailsTab',
  WorkflowEmptyState: 'WorkflowEmptyState',

  EqualToSquare: 'EqualToSquare',
  NotEqualToSquare: 'NotEqualToSquare',
  ContainsSquare: 'ContainsSquare',
  DoesNotContainsSquare: 'DoesNotContainsSquare',
  HasAnyValueSquare: 'HasAnyValueSquare',
  HasNoValueSquare: 'HasNoValueSquare',
  IsTrueSquare: 'IsTrueSquare',
  IsFalseSquare: 'IsFalseSquare',
  LessThanSquare: 'LessThanSquare',
  GreaterThanSquare: 'GreaterThanSquare',
  SettingsMedium: 'SettingsMedium',
  OngoingTask: 'OngoingTask',
  CompletedTask: 'CompletedTask',
  Alias: 'Alias',
  BranchActive: 'BranchActive',
  AliasActive: 'AliasActive',
  Branch: 'Branch',
  GlobalFieldSelectedSmall: 'GlobalFieldSelectedSmall',
  CopyUrl: 'CopyUrl',
  CopyUrlTiny: 'CopyUrlTiny',
  BranchTree: 'BranchTree',
  AliasName: 'AliasName',
  BranchIcon2: 'BranchIcon2',
  Information2: 'Information2',
  AliasLarge: 'AliasLarge',
  Asset: 'Asset',
  Bucket: 'Bucket',
  Rocket,
  BucketLight,
  RocketLight,
  CellNetwork,
  Pie,
  Bandwidth,
  ApiCalls,
  BranchSetting: 'BranchSetting',
  HoverAlias: 'HoverAlias',
  ClickAlias: 'ClickAlias',
  NoBranch: 'NoBranch',
  RedAlert: 'RedAlert',
  BranchLarge: 'BranchLarge',
  MarketplaceSmallFilled: 'MarketplaceSmallFilled',
  MarketplaceSmallFilledWhite: 'MarketplaceSmallFilledWhite',
  MarketplaceSmallFilledGray: 'MarketplaceSmallFilledGray',
  Marketplace: 'Marketplace',
  ExtensionPurpleCircle: 'ExtensionPurpleCircle',
  ExtensionSmallFilled: 'ExtensionSmallFilled',
  ABTesting: 'ABTesting',
  ABTestingAnalytics: 'ABTestingAnalytics',
  ABTestingMetrics: 'ABTestingMetrics',
  ABTestingTargeting: 'ABTestingTargeting',
  AudienceExperience: 'AudienceExperience',
  AndDark: 'AndDark',
  ScholarHat: 'ScholarHat',
  ScholarHatActiveIcon: 'ScholarHatActiveIcon',
  UploadIcon: 'UploadIcon',
  RefreshCircleThin: 'RefreshCircleThin',
  RefreshCircle: 'RefreshCircle',
  InfoGreen: 'InfoGreen',
  InfoYellow: 'InfoYellow',
  PersonalizationEvents: 'PersonalizationEvents',
  PersonalizationEventsActive: 'PersonalizationEventsActive',
  PersonalizationEventsLarge: 'PersonalizationEventsLarge',
  GreyAdd: 'GreyAdd',
  ViewNestedEntries: 'ViewNestedEntries',
  PlusGreySmall: 'PlusGreySmall',
  MinusGreySmall: 'MinusGreySmall',
  BackArrowSquare: 'BackArrowSquare',
  ArrowSquare: 'ArrowSquare',
  DoubleArrowSquare: 'DoubleArrowSquare',
  RecurrsSquare: 'RecurrsSquare',
  RefreshEntries: 'RefreshEntries',
  RefreshEntriesThin: 'RefreshEntriesThin',
  Description: 'Description',
  Scope: 'Scope',
  Stage: 'Stage',
  SuperUser: 'SuperUser',
  Activation: 'Activation',
  CancelMedium: 'CancelMedium',
  CancelSmall: 'CancelSmall',
  RestoreThin: 'RestoreThin',
  RestoreThinLight: 'RestoreThinLight',
  RemoveGrey: 'RemoveGrey',
  ArrowRight: 'ArrowRight',
  ArrowRightWhite: 'ArrowRightWhite',
  ExpandArrow: 'ExpandArrow',
  CollapseArrow: 'CollapseArrow'
}
